import { signOrder } from '@/api/comm'
import { pay as paymentAction } from '@/common/pay/pay'

export function pay(orderId, type) {
  return signOrder({ orderId }).then((pay) => {
    paymentAction(pay.data)
    let title = '支付结果'
    if (type) {
      title = type + '信息确认'
    }
    let text = '请您在新打开的网上银行页面进行支付，支付完成前请不要关闭窗口'
    let buttonText = '已完成支付'
    this.$JalertModal(orderId, title, text, buttonText, () => {
      this.$router.push({
        path: '/orderDetail',
        query: {
          order: orderId,
        },
      })
    })
    return pay.data
  })
}
